<template>
  <div>
    <v-form ref="form" class="pt-8">
      <v-container>
        <v-row>
          <v-col cols="12">
              <h3 class="title mr-4 p-2">{{ $t('enviar_mensajes') }}</h3>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.width < 960 ? 12 : 4">
            <div class="mr-1 p-2">
              {{ $t('mensaje_nombre') }}
              <v-text-field v-model="nombre" :rules="inputRules" outlined dense ></v-text-field>
            </div>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.width < 960 ? 12 : 4">
            <div class="mr-1 ml-1 p-2">
              {{ $t('mensaje_telefono') }}
              <v-text-field v-model="telefono" outlined dense></v-text-field>
            </div>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.width < 960 ? 12 : 4">
            <div class="mr-1 ml- p-2">
              {{ $t('mensaje_email') }}
              <v-text-field v-model="email" outlined :rules="inputRules" dense type="email"></v-text-field>
            </div>
          </v-col>
          <v-col cols="12">
            <div class="p-2">
              {{ $t('mensaje_comentario') }}
               <v-textarea v-model="mensaje" :rules="inputRules" outlined></v-textarea>
            </div>   
          </v-col>
          <v-col cols="2">
            <div class="mr-2 p-2">
              <v-btn depressed large color="error" @click="sendEmail()">{{ $t('enviar_mensaje') }}</v-btn>
            </div>
          </v-col>
          <v-col cols="12" class="pt-0" align="center">
            <v-container class="pt-0">
              <v-row no-gutters>
                <CardCars/>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
        <!-- <v-row class="pt-12">
          <CardCars/>
        </v-row> -->
      </v-container>
    </v-form>
    <!-- Modal Sending  Mail  -->
    <v-dialog v-model="modalSendMail" persistent width="350">
      <v-card color="white" dark>
        <v-card-title style="margin-left: 60px; color: black">
          {{ tituloModal}}
        </v-card-title>
        <v-card-text>
         <v-progress-circular
            style="margin-left:120px;"
            :size="50"
            :width="8"
            color="red"
            indeterminate
          ></v-progress-circular>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import emailjs from 'emailjs-com';
import emailjs from '@emailjs/browser'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import CardCars from '../components/CardCars.vue';

export default {
  name: 'Contacto',
  components: {
    CardCars
  },
   data: () => ({
    carouselAutosSettings :{
			autoPlay:true,
			infiniteScroll:true,
			wheelControl:false,
			playSpeed:"3000" ,
			centerMode:false,
			transition:"500",
			breakpoints: {
				1000: {
					itemsToShow: 4
        },
        960:{
          itemsToShow: 2
        },
			  600: {
					itemsToShow: 1
				},
				0: {
				  itemsToShow: 1,
          autoPlay:false,
				}
      }
    },
      numPage: 4,
       modalSendMail : false,
       tituloModal : '',
       valid: true,
       errors: false,
       nombre : '',
       telefono :'',
       email:'',
       mensaje:'',
       inputRules : [
          v => !!v || 'Este campo es requerido.',
       ],
         
  }),
  methods: {
    validate () { 
      /*Si algunas de las Rules no cumple,la funcion retornara 'false' */
      if (this.$refs.form.validate()) {
        return this.errors = true
      } else {
        return this.errors = false
      }
    },
    sendEmail() {
      // validamos los campos requeridos
      if(!this.validate()) return
      //obtenemos los datos de los campos para enviarlos
      let data = {
        user_name: this.nombre,
        user_email: this.email,
        user_phone:this.telefono,
        message: this.mensaje
      };
      // mostramos el modal de sending email ..
      this.modalSendMail = true
      this.tituloModal ='Enviando Mensaje ...'
      // Enviamos el mensaje
      //emailjs.send('rada_serviceEmail', 'template_radaContact', data, 'user_gCFBInKaXgleOcZA2NsMV')
      emailjs.send('service_6ytjzyb', 'template_ugghjcq', data, {
        publicKey: 'N06ihyqqdUd9IXdR9'
      })
        .then((result) => {
          if(result.status == 200){
            this.modalSendMail = false
            this.$refs.form.resetValidation()
            //mostramos mensaje de confirmacion
            this.limpiarCampos()
            Swal.fire({
              title: 'Mensaje Enviado',
              text: 'Gracias por contactarnos',
              icon: 'success',
              confirmButtonText: 'Aceptar',
              timer: 3000
            })
          }
        },
        (error) => {
          console.error('FAILED...', error);
          this.modalSendMail = false
          //this.limpiarCampos()
        });
    },
    limpiarCampos() {
      this.nombre = ' '
      this.email = ' '
      this.telefono = ''
      this.mensaje = ''
    }
  }
}
</script>
